// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"0349c9e1","118":"34bce741","187":"a28584ef","378":"53aeaaaf","502":"44b09f62","533":"19b01da1","592":"73cb1d0b","787":"b8114e63","937":"43efeab0"}[chunkId] + ".chunk.js";
};